export const DocumentVersionInfo: any = [
    {
        id: 1,
        no: 1,
        title: "MVA-Vendor-Signed1.PDF",
        updated: "07/11/2024 10:32:34 AM"
    },
    {
        id: 2,
        no: 2,
        title: "MVA-Vendor-Signed2.PDF",
        updated: "08/11/2024 10:32:34 AM"
    },
    {
        id: 3,
        no: 3,
        title: "MVA-Vendor-Signed3.PDF",
        updated: "09/11/2024 10:32:34 AM"
    },
    {
        id: 4,
        no: 4,
        title: "MVA-Vendor-Signed4.PDF",
        updated: "10/11/2024 10:32:34 AM"
    }
]